<template>
    <v-dialog v-model="dialog" :width="width">
        <v-card flat>
            <v-card-title class="pl-3 justify-center">{{ title }}</v-card-title>
            <v-divider class="mb-0"></v-divider>
            <mails :mails="emails"/>
            <v-divider class="mb-0"></v-divider>
            <v-card-actions class="mt-2">
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="closeDialog">Close</v-btn>
            </v-card-actions>
        </v-card>        
    </v-dialog>
</template>

<script>
    import mails from '@/components/ui/tables/mails.vue';

    export default {    
        props:{
            width:{
                type: String,
                default: '900px'
            }
        },        
        components: {
            mails,
        },
        data() {
            return {
                dialog: false,
                title: "",
                emails: [],
            }
        },
        methods: {
            closeDialog(){
                this.dialog = false;
            },
            openDialog(mType, mKey, mTitle) {
                this.dialog = false;
                this.title = mTitle;
                this.$axios.post("ares/json/ares/misc/getEmails.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getEmails",
                    },
                    getEmails: {
                        mail_type: mType,
                        mail_key: mKey,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.emails = res.data.getEmails.emails;
                        this.dialog = true;
                    }
                });
            },
        },
    };
</script>